import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { LinkButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";
import { openTrialUpgradeUrl } from "app/pages/sales-intelligence/pages/premium-features/trial";

type TrialContentProps = {
    hasPartialCredits?: boolean;
};

const TrialContent = ({ hasPartialCredits = false }: TrialContentProps) => {
    const { translate } = useTranslate();

    const onUpgradeClick = () => openTrialUpgradeUrl("not-enough-quota-tooltip");

    return (
        <Stack
            gap="4px"
            data-automation="trial-not-enough-quota-content"
        >
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.carbon[0]}
            >
                {hasPartialCredits
                    ? translate(quotaKeys.insufficientCreditsTitle)
                    : translate(quotaKeys.needMoreCreditsTitle)}
            </Text>

            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                <Trans i18nKey={quotaKeys.trialNeedMoreCredits} />
            </Text>

            <Text
                fontVariant="tooltip"
                color={colorsPalettes.blue["300"]}
                onClick={onUpgradeClick}
                cursor="pointer"
            >
                {translate("si.common.upgrade_now")}
            </Text>
        </Stack>
    );
};

export default TrialContent;
